import * as React from 'react';

import { cn } from '@/shadcn/lib/utils';

type CustomProps = {
  invalid?: boolean;
};

const Input = React.forwardRef<
  HTMLInputElement,
  CustomProps & React.ComponentProps<'input'>
>(({ className, type, invalid, ...props }, ref) => (
  <input
    aria-invalid={invalid}
    className={cn(
      'flex h-10 w-full rounded-md border border-input bg-muted px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-accent',
      invalid && 'border-destructive focus-visible:ring-destructive/70',
      className
    )}
    ref={ref}
    type={type}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
